import { FormProvider, useForm } from 'react-hook-form';

import { PrevHeaderBarWithTitleTemplate } from '#templates';
import { useMutation, useQuery } from '@tanstack/react-query';
import request, { axios } from '#api/axios';
import { Link } from 'react-router-dom';
import { BoxIcon } from '#atoms';
import { useToast } from '#providers/ToastProvider';

const GymEdit = () => {
  const methods = useForm({});

  const { showToast } = useToast();

  const { data } = useQuery({
    queryKey: ['get-coach-gym-list'],
    queryFn: async () => {
      const res = await request<
        Array<{
          name: string;
          address: string;
          resizedLink: string;
          id: string;
        }>
      >({
        method: 'get',
        url: `/gyms/coach/all`
      });
      return res.data;
    }
  });

  const { mutate } = useMutation({
    mutationFn: (payload: string) =>
      axios.patch(`gyms/coach/list`, {
        gymId: payload
      }),
    onSuccess: () => {
      showToast({
        message: '수업 장소를 삭제하였습니다.'
      });
    },
    onError: () => {
      showToast({
        type: 'fail',
        message: '일시적인 오류입니다. 다시 시도해주세요.'
      });
    }
  });

  return (
    <PrevHeaderBarWithTitleTemplate
      title="수업 장소"
      defaultBackground
      prevRoute="../."
    >
      <FormProvider {...methods}>
        <form className="p-20 flex flex-col gap-12 h-full">
          <div className="flex flex-col gap-16">
            {data &&
              data.map(value => {
                return (
                  <div
                    className="flex justify-between items-center gap-12"
                    key={value.id}
                  >
                    <div className="flex items-center justify-start gap-12 flex-1">
                      <img
                        src={value.resizedLink}
                        className="w-56 h-56 rounded-full object-cover"
                      />
                      <div className="w-[80%] flex flex-col gap-4">
                        <p className="text-[#EAE8ED]">{value.name}</p>
                        <p className="text-[#8E899F] text-[14px] text-ellipsis overflow-hidden whitespace-nowrap max-w-[90%]">
                          {value.address}
                        </p>
                      </div>
                    </div>
                    <button type="button" onClick={() => mutate(value.id)}>
                      <BoxIcon type="x-gray" size={12} onlyIcon />
                    </button>
                  </div>
                );
              })}
          </div>
          <Link
            to="add"
            className="w-full bg-[#9170F2] text-[EAE8ED] py-16 rounded-8 text-center self-end mt-auto"
          >
            장소 추가
          </Link>
        </form>
      </FormProvider>
    </PrevHeaderBarWithTitleTemplate>
  );
};

export default GymEdit;
